<div class="flex flex-col h-full">

  <!-- Header -->
  <div class="flex flex-row items-center justify-between px-6 py-4 border-b border-grey-200">
    <span class="text-xl font-semibold text-grey-900">Service Mapping</span>
    <div class="flex items-center border border-grey-300 rounded px-3 py-1.5 bg-white w-1/2">
      <mat-icon class="text-grey-400 mr-2" style="font-size: 18px; height: 18px; width: 18px;">search</mat-icon>
      <input [formControl]="searchControl" placeholder="Search for..."
        class="outline-none text-sm flex-1 bg-transparent text-grey-700 placeholder-grey-400" />
    </div>
  </div>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="flex-1 flex items-center justify-center">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Error state -->
  <div *ngIf="loadError" class="flex-1 flex items-center justify-center">
    <span class="text-sm text-grey-500">Failed to load service taxonomy. Please try again.</span>
  </div>

  <!-- Category groups (column headers live inside the scroll container so they always align with rows) -->
  <div *ngIf="!isLoading && !loadError" class="flex-1 overflow-y-auto">

    <!-- Column headers — sticky so they stay visible on scroll, z-20 to sit above sticky category headers (z-10) -->
    <div class="flex flex-row items-center px-6 py-3 border-b border-grey-200 bg-white sticky top-0 z-20">
      <span class="w-2/5 min-w-0 pr-4 text-xs font-semibold text-grey-900 uppercase tracking-wide">MOTOR Service</span>
      <span class="flex-1 min-w-0 pr-2 text-xs font-semibold text-grey-900 uppercase tracking-wide">DMS Services</span>
      <div class="w-14 sm:w-16 md:w-20 flex justify-end">
        <button mat-icon-button (click)="toggleAll()" [title]="allCollapsed ? 'Expand All' : 'Collapse All'"
          aria-label="Toggle all categories">
          <mat-icon class="text-grey-500" style="font-size: 20px; height: 20px; width: 20px;">
            {{ allCollapsed ? 'unfold_more' : 'unfold_less' }}
          </mat-icon>
        </button>
      </div>
    </div>
    <ng-container *ngFor="let category of categories">

      <!-- Category header row -->
      <div
        class="flex flex-row items-center px-6 py-3 bg-grey-50 border-b border-grey-100 category-accent-border cursor-pointer hover:bg-grey-100 sticky top-16 z-10"
        (click)="toggleCategory(category)">
        <span class="flex-1 pr-4 font-semibold text-sm text-grey-700 uppercase tracking-wide">{{ category.name }}</span>
        <div class="w-20 flex items-center justify-end gap-1">
          <mat-icon class="text-grey-700" style="font-size: 16px; height: 16px; width: 16px;">assignment</mat-icon>
          <span class="text-sm text-grey-700">{{ getMappedCount(category) }}/{{ category.items.length }}</span>
          <mat-icon class="text-grey-700" style="font-size: 20px; height: 20px; width: 20px;">
            {{ category.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
          </mat-icon>
        </div>
      </div>

      <!-- Item rows -->
      <ng-container *ngIf="!category.collapsed">
        <ng-container *ngIf="getFilteredItems(category) as filteredItems">
          <div *ngFor="let item of filteredItems"
            class="flex flex-row items-center px-6 py-3 border-b border-grey-100 hover:bg-grey-50">
            <span class="w-2/5 min-w-0 pr-4 text-sm text-grey-700">{{ item.motorServiceName }}</span>
            <span class="flex-1 min-w-0 pr-2 flex items-center gap-2"
              *ngIf="item.linkedServices.length > 0; else noMapping">
              <span *ngIf="item.linkedServices.length === 1" class="op-code-chip shrink-0">
                {{ item.linkedServices[0].opCode }}
              </span>
              <span class="text-sm text-grey-700 truncate">{{ getLinkedNames(item) }}</span>
              <span *ngIf="getLinkedOverflow(item) > 0"
                class="shrink-0 text-xs text-blue-700 bg-blue-100 rounded px-2 py-0.5 whitespace-nowrap">
                +{{ getLinkedOverflow(item) }} more
              </span>
            </span>
            <ng-template #noMapping>
              <span class="flex-1 min-w-0 pr-2 text-sm text-grey-400">&mdash;</span>
            </ng-template>
            <div class="w-6 sm:w-8 md:w-12 flex justify-end">
              <button mat-icon-button (click)="editMapping(item)" [disabled]="!serviceGroupsLoaded"
                aria-label="Edit mapping for {{ item.motorServiceName }}">
                <mat-icon style="font-size: 18px; height: 18px; width: 18px; color: #0054a6;">open_in_new</mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>

    </ng-container>
  </div>

</div>